/**
 * User Avatar Component
 *
 * Displays user avatar with fallback to initials or nothing
 */

import React from "react";
import { Link } from "react-router-dom";
import NavigationStylesExport from "../NavigationStyles";

const UserAvatar = ({
  username,
  userImageUrl,
  avatarInitial,
  size = "medium",
}) => {
  const { HEADER_STYLES } = NavigationStylesExport;
  const sizeClasses = {
    small: HEADER_STYLES.avatarSmall,
    medium: HEADER_STYLES.avatarMedium,
    large: HEADER_STYLES.avatarLarge,
  };

  if (userImageUrl) {
    return (
      <Link to="/profile" className="block">
        <div
          className={`${sizeClasses[size]} ${HEADER_STYLES.avatarRounded} ${HEADER_STYLES.avatarOverflow} cursor-pointer hover:ring-2 hover:ring-violet-400 hover:ring-opacity-50 transition-all duration-200`}
        >
          <img
            src={userImageUrl}
            alt={username || "User"}
            className="w-full h-full object-cover"
          />
        </div>
      </Link>
    );
  }

  // Use avatarInitial if provided (from useUserData hook), otherwise fall back to first letter of username
  const initial = avatarInitial || username?.charAt(0)?.toUpperCase();

  if (initial) {
    return (
      <Link to="/profile" className="block">
        <div
          className={`${sizeClasses[size]} ${HEADER_STYLES.avatarRounded} ${HEADER_STYLES.avatarGradient} flex items-center justify-center ${HEADER_STYLES.avatarText} ${HEADER_STYLES.avatarBorder} cursor-pointer hover:ring-2 hover:ring-violet-400 hover:ring-opacity-50 transition-all duration-200`}
        >
          {initial}
        </div>
      </Link>
    );
  }

  return null;
};

export default UserAvatar;
